export const env = {
  baseUrl: "https://tstvendor.hassad.com/",
  errorMsg: "Error occured while processing your request!",
  pageSize: 10,
  userInfo: "",
  dateFormat: "DD-MMM-YYYY",
  taxName: "",
  baseCountry: "qa",
  baseCurrency: "",
  paymentTerm: "",
  orgId: "",
  suppId: "",
  serverDate: "",
};

export const env_url = {
  login: "api/auth/login",
  getCSRFToken: "api/auth/getToken",
  validatetoken: "api/auth/refresh",
  loadUser: "api/usrmgmt/loadUser",
  supplierRegistration: "api/auth/supplierRegistration",
  getALLCountries: "api/auth/getALLCountries",
  checkUserNameSR: "api/auth/checkUserName",
  checkEmailIdSR: "api/auth/checkEmailId",
  checkMobileNoSR: "api/auth/checkMobileNo",
  checkSupplierNameSR: "api/auth/checkSupplierName",
  forgotPassword: "api/auth/forgotPassword",
  changePasswordSR: "api/auth/changePassword",
  getAllActiveUsers: "api/usrmgmt/getAllActiveUsers",
  getAllUsers: "api/usrmgmt/getALLUsersList",
  getAllRoles: "api/usrmgmt/getALLRolesList",
  getAllApprovers: "api/usrmgmt/getAllApprovers",
  getAllOrgUsers: "api/usrmgmt/getAllOrgUsers",
  getAllWPOrgUsers: "api/usrmgmt/getAllWPOrgUsers",
  getAllSupplierUsers: "api/usrmgmt/getAllSupplierUsers",
  getAllMigratedUsers: "api/usrmgmt/getAllMigratedOrgUsers",
  inviteMigratedUser: "api/usrmgmt/inviteMigratedUser",
  getAllOrgRoles: "api/usrmgmt/getAllOrgRoles",
  getAllAppFunctions: "api/usrmgmt/getAllAppFunctions",
  getAllAppFunctionsForSuppliers: "api/usrmgmt/getAllAppFunctionsForSuppliers",
  createSRMSRole: "api/usrmgmt/createSRMSRole",
  editSRMSRole: "api/usrmgmt/editSRMSRole",
  deleteSRMSRole: "api/usrmgmt/deleteSRMSRole",
  getSRMSUser: "api/usrmgmt/getSRMSUser",
  createSRMSNewUsers: "api/usrmgmt/processSRMSNewUsers",
  editSRMSUserDetails: "api/usrmgmt/editSRMSUserDetails",
  uploadProfilePhoto: "api/usrmgmt/uploadProfilePhoto",
  getLoggedInUser: "api/usrmgmt/getLoggedInUser",
  checkUserName: "api/usrmgmt/checkUserName",
  checkEmailId: "api/usrmgmt/checkEmailId",
  checkMobileNo: "api/usrmgmt/checkMobileNo",
  resetPassword: "api/usrmgmt/resetUserPassword",
  changePassword: "api/usrmgmt/changePassword",
  enableDisableUser: "api/usrmgmt/enableDisableUser",
  getSupplierByUserId: "api/usrmgmt/getSupplierByUserId",
  getUsersByDepartment: "api/usrmgmt/getAllUsersByDepartment",
  getRoleAuthorize: "api/usrmgmt/getRoleAuthorize",
  validateOtp: "api/auth/validateOtp",
  resendOtp: "api/auth/resendOtp",
  assignRole: "api/usrmgmt/assignRoles",
  /** Starts Delegation Roles  */
  getAllRoleDelegations: "api/usrmgmt/getAllRoleDelegations",
  addRoleDelegation: "api/usrmgmt/addRoleDelegation",
  cancelRoleDelegations: "api/usrmgmt/cancelRoleDelegations",
  getRoleDelegationByUserName: "api/usrmgmt/getRoleDelagationByFromUser",
  /** Ends Delegation Roles  */
  getAllEmployees: "api/usrmgmt/getAllEmployees",
  getAllUsersByRole: "api/usrmgmt/getAllUsersByRole",
  getDelegateUser: "api/usrmgmt/getdelegationrulesbyuser",

  /** Administration */
  getALLBusinessEntities: "api/admmgmt/getALLBusinessEntities",
  getALLMasterDataEntities: "api/admmgmt/getALLMasterDataEntities",
  getMigratedList: "api/admmgmt/getAllMigratedComplanyList",
  getALLExtSysTrxnDtls: "api/admmgmt/getALLExtSysTrxnDtls",
  getALLBusinessSegMst: "api/admmgmt/getALLBusinessSegMst",
  getALLBusinessSegDtls: "api/admmgmt/getALLBusinessSegDtls",
  addBusSegMst: "api/admmgmt/addBusSegMst",
  addUpdateAllBusSegDtl: "api/admmgmt/addUpdateAllBusSegDtl",
  addBusSegDtl: "api/admmgmt/addBusSegDtl",
  deleteBusSegDtl: "api/admmgmt/deleteBusSegDtl",
  actDeActBusSegDtl: "api/admmgmt/actDeActBusSegDtl",
  getALLSegment2BySeg1: "api/admmgmt/getALLSegment2BySeg1",
  getALLCurrencies: "api/admmgmt/getALLCurrencies",
  getCountryList: "api/admmgmt/getCountryList",
  getALLLocationsById: "api/admmgmt/getALLLocationsById",
  /** Basic Settings */
  getALLLocations: "api/admmgmt/getALLLocations",
  getALLActiveLocations: "api/admmgmt/getALLActiveLocations",
  addLocation: "api/admmgmt/addLocation",
  editLocation: "api/admmgmt/editLocation",
  deleteLocation: "api/admmgmt/deleteLocation",
  actDeActLocation: "api/admmgmt/actDeActLocation",
  getALLPaymentTerms: "api/admmgmt/getALLPaymentTerms",
  getALLActivePaymentTerms: "api/admmgmt/getALLActivePaymentTerms",
  addPaymentTerms: "api/admmgmt/addPaymentTerms",
  editPaymentTerms: "api/admmgmt/editPaymentTerms",
  deletePaymentTerms: "api/admmgmt/deletePaymentTerms",
  actDeActPaymentTerms: "api/admmgmt/actDeActPaymentTerms",
  getALLTaxCodes: "api/admmgmt/getALLTaxCodes",
  getALLActiveTaxCodes: "api/admmgmt/getALLActiveTaxCodes",
  addTaxCode: "api/admmgmt/addTaxCode",
  editTaxCode: "api/admmgmt/editTaxCode",
  deleteTaxCode: "api/admmgmt/deleteTaxCode",
  actDeActTaxes: "api/admmgmt/actDeActTaxes",
  getOrganizationInfo: "api/admmgmt/getOrganizationInfo",
  updateOrgInfo: "api/admmgmt/updateOrgInfo",
  changeOrgLogo: "api/admmgmt/changeOrgLogo",
  updateOrgPreferences: "api/admmgmt/updateOrgPreferences",
  getAllSubsidiaries: "api/admmgmt/getAllSubsidiaries",
  getSubsidiaryImage: "api/admmgmt/getSubsidiaryImage",
  processSubsidiary: "api/admmgmt/processSubsidiary",
  getSubsidiaryById: "api/admmgmt/getSubsidiaryById",
  getALLAppProperties: "api/admmgmt/getALLAppProperties",
  setAppProperty: "api/admmgmt/setAppProperty",
  getAppProperty: "api/admmgmt/getAppProperty",
  getLookupsByKey: "api/admmgmt/getLookupsByKey",
  createNewTnC: "api/admmgmt/createNewTnC",
  getAllTnCs: "api/admmgmt/getAllTnCs",
  getAllTnCByModuleName: "api/admmgmt/getAllTnCByModuleName",
  getTnCById: "api/admmgmt/getTnCById",

  /** Manage Lookups */
  getALLLookups: "api/admmgmt/getALLLookUpValues",
  addLookup: "api/admmgmt/addLookup",
  editLookup: "api/admmgmt/editLookup",
  deleteLookup: "api/admmgmt/deleteLookup",
  actDeActLookup: "api/admmgmt/actDeActLookup",

  /** Setup Notification */
  getALLNotifs: "api/admmgmt/getALLNotifs",
  getALLNotifsTypes: "api/admmgmt/getALLNotifsTypes",
  addNotification: "api/admmgmt/addNotification",
  deleteNotification: "api/admmgmt/deleteNotification",
  editNotification: "api/admmgmt/editNotification",
  getRoleUsers: "api/admmgmt/getRoleUsers",

  /** Approval Workflow */
  getALLWFDefinitions: "api/admmgmt/getALLWFDefinitions",
  addWFStep: "api/admmgmt/addWFStep",
  addWFAssignee: "api/admmgmt/addWFAssignee",
  deleteWFStep: "api/admmgmt/deleteWFStep",
  deleteWFAssignee: "api/admmgmt/deleteWFAssignee",
  editWFStepTitle: "api/admmgmt/editWFStepTitle",
  getWFDefinitionById: "api/admmgmt/getWFDefinitionById",
  submitBidResponseProxy: "api/bidmgmt/submitBidResponseProxy",

  /** Amount based Approvers */
  getALLAmtBasedApprovers: "api/admmgmt/getALLAmtBasedApprovers",
  processAmtBasedApprovers: "api/admmgmt/processAmtBasedApprovers",
  deleteAmtBasedApprovers: "api/admmgmt/deleteAmtBasedApprovers",
  collectFees: "api/bidmgmt/collecttenderfee",
  updateFees: "api/bidmgmt/updatetenderfeestatus",
  extendBid: "api/bidmgmt/extendBid",
  getBidStatusAnalytics: "api/bidmgmt/getPublishedBidsStatusAnalytics",
  bidReEvaluation: "api/bidmgmt/bidReEvaluation",

  /** Budgets */
  getALLPeriods: "api/admmgmt/getALLPeriods",
  getPeriodById: "api/admmgmt/getPeriodById",
  getBudgets: "api/admmgmt/getALLBudgets",
  getALLBudgets: "api/admmgmt/getALLApprovedBudgets",
  getALLBudgetOwners: "api/admmgmt/getALLBudgetOwners",
  getBudgetById: "api/admmgmt/getBudgetById",
  addBudget: "api/admmgmt/addBudget",
  addBudgetLine: "api/admmgmt/addBudgetLine",
  addBudgetPeriodAmtMap: "api/admmgmt/addBudgetPeriodAmtMap",
  addBudgetDepartMap: "api/admmgmt/addBudgetDepartMap",
  addBudgetLocMap: "api/admmgmt/addBudgetLocMap",
  deleteBudget: "api/admmgmt/deleteBudget",
  deleteBudgetLine: "api/admmgmt/deleteBudgetLine",
  calculateBudgetTotal: "api/admmgmt/calculateBudgetTotal",
  processBudgetNotes: "api/admmgmt/processBudgetNotes",
  submitBudgetApproval: "api/admmgmt/submitBudgetApproval",
  processBudgetApprovalStep: "api/admmgmt/processBudgetApprovalStep",
  reviseBudget: "api/admmgmt/reviseBudget",
  getBudgetRevisionHst: "api/admmgmt/getBudgetRevisionHst",
  copyBudget: "api/admmgmt/copyBudget",

  /** Feedbacks */
  submitFeedback: "api/admmgmt/submitFeedback",
  getALLFeedbacks: "api/admmgmt/getALLFeedbacks",
  getFeedbackById: "api/admmgmt/getFeedbackById",
  getFeedbackAnalysis: "api/admmgmt/getFeedbackAnalysis",
  resendReminder: "api/admmgmt/resendtasknotif",

  /** Suppliers */
  getALLSuppliers: "api/suppmgmt/getALLSuppliers",
  getALLInternalSuppliers: "api/suppmgmt/getALLInternalSuppliers",
  getALLActiveSuppliers: "api/suppmgmt/getALLActiveSuppliers",
  getSupplierObject: "api/suppmgmt/getSupplierbyId",
  getSupplierDetails: "api/suppmgmt/getSupplierDetailsById",
  getSupplierUserAccount: "api/suppmgmt/getSupplierUserAccount",
  getAllInvitations: "api/suppmgmt/getAllInvitations",
  inviteSupplier: "api/suppmgmt/inviteSupplier",
  inviteBulkSupplier: "api/suppmgmt/bulkSuppliersInvite",
  editMigratedSupplier: "api/suppmgmt/updateSupplierEmailId",
  resendInvitation: "api/suppmgmt/resendInvitation",
  resendEditInvitation: "api/suppmgmt/updateInvitation",
  cancelInvitation: "api/suppmgmt/cancelInvitation",
  sendAlertForAllSuppliers: "api/suppmgmt/sendAlertForAllSuppliers",
  getALLActiveSuppliersByCategory:
    "api/suppmgmt/getALLActiveSuppliersByCategory",
  getALLActiveSuppliersByCategories:
    "api/suppmgmt/getALLActiveSuppliersByCategories",
  getALLMigratedSuppliers: "api/suppmgmt/getALLMigratedSuppliers",
  getAllUnRegisterSuppliers: "api/suppmgmt/getAllUnregSupplier",
  postenabledisablesupplierdetails: "api/suppmgmt/supplierdetailsenabledisable",
  postUnregisterSupplier:
    "api/registrationmgmt/unregisteredSupplierRegistration",
  /** Sourcing */
  getALLPRs: "api/esourcemgmt/getALLPRs",
  getPRObject: "api/esourcemgmt/getPRbyPrNumber",
  getMRObject: "api/esourcemgmt/getMRbyMrNumber",
  getALLMRs: "api/esourcemgmt/getALLMRs",
  createMR: "api/esourcemgmt/createMR",
  updateMR: "api/esourcemgmt/updateMR",
  deleteMR: "api/esourcemgmt/deleteMR",
  createPR: "api/esourcemgmt/createPR",
  updatePR: "api/esourcemgmt/updatePR",
  deletePR: "api/esourcemgmt/deletePR",
  processPRNotes: "api/esourcemgmt/processPRNotes",
  processMRNotes: "api/esourcemgmt/processMRNotes",
  addPRLine: "api/esourcemgmt/addPRLine",
  addMRLine: "api/esourcemgmt/addMRLine",
  editPRLine: "api/esourcemgmt/editPRLine",
  editMRLine: "api/esourcemgmt/editMRLine",
  deletePRLine: "api/esourcemgmt/deletePRLine",
  deleteMRLine: "api/esourcemgmt/deleteMRLine",
  submitPRApproval: "api/esourcemgmt/submitPRApproval",
  submitMRApproval: "api/esourcemgmt/submitMRApproval",
  holdMR: "api/esourcemgmt/holdMR",
  processPRApprovalStep: "api/esourcemgmt/processPRApprovalStep",
  processMRApprovalStep: "api/esourcemgmt/processMRApprovalStep",
  createPOFromPR: "api/esourcemgmt/createPOFromPR",
  copyPR: "api/esourcemgmt/copyPR",
  copyMR: "api/esourcemgmt/copyMR",
  cancelPR: "api/esourcemgmt/cancelPR",
  cancelMR: "api/esourcemgmt/cancelMR",
  processPRLinesImportXls: "api/esourcemgmt/processPRLinesImportXls",
  getMRItemsList: "api/admmgmt/getItemMasterList",
  getAllPreferredSuppliers: "api/esourcemgmt/getPreferredSupplier",
  getALLPOs: "api/esourcemgmt/getALLPOs",
  getPODetailsByPoNo: "api/esourcemgmt/getPODetailsByPoNo",
  createPurchaseOrder: "api/esourcemgmt/createPurchaseOrder",
  updatePO: "api/esourcemgmt/updatePO",
  deletePO: "api/esourcemgmt/deletePO",
  processPONotes: "api/esourcemgmt/processPONotes",
  copyPO: "api/esourcemgmt/copyPO",
  cancelPO: "api/esourcemgmt/cancelPO",
  addPOLine: "api/esourcemgmt/addPOLine",
  editPOLine: "api/esourcemgmt/editPOLine",
  deletePOLine: "api/esourcemgmt/deletePOLine",
  submitPOApproval: "api/esourcemgmt/submitPOApproval",
  processPOApprovalStep: "api/esourcemgmt/processPOApprovalStep",
  createDeliveryNote: "api/esourcemgmt/createDeliveryNote",
  createReceipt: "api/esourcemgmt/createReceipt",
  downloadPO: "api/esourcemgmt/downloadPO",
  checkStockItems: "api/esourcemgmt/checkStockItems",
  processPOLinesImportXls: "api/esourcemgmt/processPOLinesImportXls",
  downloadPR: "api/esourcemgmt/downloadPrDocument",
  downloadMR: "api/esourcemgmt/downloadMrDocument",
  getALLOpenPOs: "api/esourcemgmt/getALLOpenPOs",
  syncMR: "api/esourcemgmt/syncmr",
  /** Invoice Management */
  getALLInvoices: "api/invoicemgmt/getALLInvoices",
  getInvoiceDetailsById: "api/invoicemgmt/getInvoiceDetailsById",
  raisePOInvoice: "api/invoicemgmt/raisePOInvoice",
  raiseHassadPOInvoice: "api/invoicemgmt/raiseHassadPOInvoice",
  syncAllInvoices: "api/invoicemgmt/syncinvoices",
  processInvoiceNotes: "api/invoicemgmt/processInvoiceNotes",
  processInvoiceApprovalStep: "api/invoicemgmt/processInvoiceApprovalStep",
  raiseNONPOInvoice: "api/invoicemgmt/raiseNONPOInvoice",
  getPDFPreview: "api/invoicemgmt/getPDFPreview",
  processInvoicePayment: "api/invoicemgmt/processInvoicePayment",
  downloadInvoiceDocument: "api/invoicemgmt/downloadInvoiceDocument",
  checkDuplicate: "api/invoicemgmt/checkDuplicate",
  processNONPOImportXls: "api/invoicemgmt/processNONPOImportXls",
  raisePOAdvanceInvoice: "api/invoicemgmt/raisePOAdvanceInvoice",
  resubmitInvoice: "api/invoicemgmt/resubmitInvoice",
  syncInvoice: "api/invoicemgmt/syncinvoice",
  /** Collaboration Management */

  postComment: "api/collaborationmgmt/postComment",
  getALLPostedComments: "api/collaborationmgmt/getALLPostedComments",
  postDocuments: "api/collaborationmgmt/postDocuments",
  getALLPostedDocuments: "api/collaborationmgmt/getALLPostedDocuments",
  deletePostedDocument: "api/collaborationmgmt/deletePostedDocument",
  downloadPostedDocument: "api/collaborationmgmt/downloadPostedDocument",

  /** Dashboard Management */
  getMyDashboardWidgets: "api/dashboardmgmt/getMyDashboardWidgets",
  getALLPendingTasks: "api/dashboardmgmt/getALLApprovalTasks",
  getApprovalTasks: "api/dashboardmgmt/getApprovalTasks",
  /** Emails */
  getALLEmails: "api/admmgmt/getALLEmails",
  updateEmailStatus: "api/admmgmt/updateEmailStatus",
  getALLUnReadEmailsCount: "api/admmgmt/getALLUnReadEmailsCount",

  /** Product Catalogue */
  getALLProdCategories: "api/productsmgmt/getALLProdCategories",
  getALLProdCategoriesWP: "api/productsmgmt/getALLProdCategoriesWP",
  createProdCategory: "api/productsmgmt/createProdCategory",
  updateProdCategory: "api/productsmgmt/updateProdCategory",
  deleteProdCategory: "api/productsmgmt/deleteProdCategory",
  actDeActProdCategory: "api/productsmgmt/actDeActProdCategory",
  getALLProdItems: "api/productsmgmt/getALLProdItems",
  addCatalogueItem: "api/productsmgmt/addCatalogueItem",
  updateCatalogueItem: "api/productsmgmt/updateCatalogueItem",
  deleteCatalogueItem: "api/productsmgmt/deleteCatalogueItem",
  deleteCatalogueImage: "api/productsmgmt/deleteCatalogueImage",
  processProductsImportXls: "api/productsmgmt/processProductsImportXls",
  getProdCategoriesByParentCategoryId:
    "api/productsmgmt/getProdCategoriesByParentCategoryId",
  getALLProdSubCategories: "api/productsmgmt/getALLProdSubCategories",

  /** Supplier Registration */
  supplierLanding: "api/registrationmgmt/supplierLanding",
  simpleSupplierRegistration: "api/registrationmgmt/simpleSupplierRegistration",
  suppRegCompanyDetails: "api/registrationmgmt/registrationCompanyDetails",
  getCompanyDetails: "api/registrationmgmt/getCompanyDetails",
  getContactDetails: "api/registrationmgmt/getContactDetails",
  addContactDetail: "api/registrationmgmt/addContactDetail",
  editContactDetail: "api/registrationmgmt/editContactDetail",
  deleteContactDetail: "api/registrationmgmt/deleteContactDetail",
  getReferenceDetails: "api/registrationmgmt/getReferenceDetails",
  addReferenceDetail: "api/registrationmgmt/addReferenceDetail",
  editReferenceDetail: "api/registrationmgmt/editReferenceDetail",
  deleteReferenceDetail: "api/registrationmgmt/deleteReferenceDetail",
  getScopeOfSupplies: "api/registrationmgmt/getScopeOfSupplies",
  addScopeOfSupply: "api/registrationmgmt/addScopeOfSupply",
  deleteScopeOfSupplyById: "api/registrationmgmt/deleteScopeOfSupply",
  getAllBankMst: "api/registrationmgmt/getAllBankMst",
  getAllBankMstByCtry: "api/registrationmgmt/getAllBankMstByCtry",
  syncSupplier: "api/integrationmgmt/syncsupplier",
  getAllBankBranchMstByBankId: "api/registrationmgmt/getAllBankBranchMst",
  getBankDetails: "api/registrationmgmt/getBankDetails",
  addBankingDetails: "api/registrationmgmt/addBankingDetails",
  editBankingDetails: "api/registrationmgmt/editBankingDetails",
  deleteBankingDetails: "api/registrationmgmt/deleteBankingDetails",
  deleteIBankingDetails: "api/registrationmgmt/deleteIBankingDetails",
  getRegistrationDocuments: "api/registrationmgmt/getRegistrationDocuments",
  uploadRegistrationDocuments:
    "api/registrationmgmt/uploadRegistrationDocuments",
  submitRegistrationApproval: "api/registrationmgmt/submitRegistrationApproval",
  submitInternalSuppApproval: "api/registrationmgmt/submitInternalSuppApproval",
  processRegistrationApprovalStep:
    "api/registrationmgmt/processRegistrationApprovalStep",
  downloadRegistrationDocuments:
    "api/registrationmgmt/downloadRegistrationDocuments",
  deleteRegistrationDocuments:
    "api/registrationmgmt/deleteRegistrationDocuments",
  createSuppUser: "api/suppmgmt/createSuppUser",
  getALLSuppUsersList: "api/suppmgmt/getAllSupplierAditionalUsersList",
  submitUpdateRegistrationApproval:
    "api/registrationmgmt/submitUpdateRegistrationApproval",
  processUpdateRegistrationApprovalStep:
    "api/registrationmgmt/processUpdateRegistrationApprovalStep",
  enablecontactbank: "api/registrationmgmt/enableordisableutilities",
  /** Spend Analytics */
  getSpendAnalyticsWidgets: "api/reportmgmt/getSpendAnalyticsWidgets",
  getSpendBySuppliers: "api/reportmgmt/getSpendBySuppliers",
  getSpendByDepartments: "api/reportmgmt/getSpendByDepartments",
  getSpendTrend: "api/reportmgmt/getSpendTrend",
  getSpendByCategories: "api/reportmgmt/getSpendByCategories",
  getBudgetVsSpend: "api/reportmgmt/getBudgetVsSpend",
  getDetailSpendByCategory: "api/reportmgmt/getDetailSpendByCategory",
  getDetailSpendByDepartment: "api/reportmgmt/getDetailSpendByDepartment",
  getDetailSpendTrend: "api/reportmgmt/getDetailSpendTrend",
  getDetailSpendByBudget: "api/reportmgmt/getDetailSpendByBudget",
  getDetailSpendBySupplier: "api/reportmgmt/getDetailSpendBySupplier",
  getAvgApprovalsTime: "api/reportmgmt/getAvgApprovalsTime",
  getPurchaseCycleTime: "api/reportmgmt/getPurchaseCycleTime",
  getTopApprovers: "api/reportmgmt/getTopApprovers",
  getAllSupplierReport: "api/reportmgmt/getAllSuppliersSummaryReport",
  getMRLandingExportReport: "api/reportmgmt/getALLMRsReport",
  getBidLandingExportReport: "api/reportmgmt/getAllBidsReport",
  getUserActivitiesExportReport: "api/reportmgmt/getALLAuditReport",
  updateJKSPasswords: "api/reportmgmt/update-jks-passwords",
  /** Inventory */
  getALLWarehouses: "api/inventorymgmt/getALLWarehouses",
  addWarehouse: "api/inventorymgmt/addWarehouse",
  updateWarehouse: "api/inventorymgmt/updateWarehouse",
  deleteWarehouse: "api/inventorymgmt/deleteWarehouse",
  getWarehouseById: "api/inventorymgmt/getWarehouseById",
  updateWarehouseStatus: "api/inventorymgmt/updateWarehouseStatus",
  getAllInventoryItems: "api/inventorymgmt/getAllInventoryItems",
  processWMSItem: "api/inventorymgmt/processWMSItem",
  getWarehouseItemById: "api/inventorymgmt/getWarehouseItemById",
  deleteWmsItem: "api/inventorymgmt/deleteWmsItem",
  getAllWarehouseItems: "api/inventorymgmt/getAllWarehouseItems",

  /** Subscription */
  getMySubscriptionInfo: "api/subscriptionmgmt/getMySubscriptionInfo",
  getAllAvailablePlans: "api/subscriptionmgmt/getAllAvailablePlans",
  getSubscriptionPlanById: "api/subscriptionmgmt/getSubscriptionPlanById",
  getPlanByNoOfUsers: "api/subscriptionmgmt/getPlanByNoOfUsers",
  processSubscription: "api/subscriptionmgmt/processSubscription",
  getAllSubscriptionInvoices: "api/subscriptionmgmt/getAllSubscriptionInvoices",
  runtimeSubscriptionInvoicePdf:
    "api/subscriptionmgmt/runtimeSubscriptionInvoicePdf",
  subscriptionInvoicePdf: "api/subscriptionmgmt/subscriptionInvoicePdf",

  /** Site API -- Free Trail/Book a Demo */
  registerTrail: "api/saasmgmt/registerTrail",
  verifyTenant: "api/saasmgmt/verifyTenant",
  requestDemo: "api/saasmgmt/requestDemo",
  contactUs: "api/saasmgmt/contactus",
  contactUsNew: "api/saasmgmt/contactsUs",
  makeRightChoice: "api/saasmgmt/makeRightChoice",
  careers: "api/saasmgmt/career",

  /** Reports API */
  getSuppliersSummaryReport: "api/reportmgmt/getSuppliersSummaryReport",
  getPRSummaryReport: "api/reportmgmt/getPRSummaryReport",
  getMRSummaryReport: "api/reportmgmt/getMRSummaryReport",
  getBidSummaryReport: "api/reportmgmt/getBidsSummaryReport",
  getPOSummaryReport: "api/reportmgmt/getPOSummaryReport",
  getInvoiceSummaryReport: "api/reportmgmt/getInvoiceSummaryReport",
  getApplicationUsersReport: "api/reportmgmt/getApplicationUsersReport",
  getBudgetsSummaryReport: "api/reportmgmt/getBudgetsSummaryReport",
  getCatalogueSummaryReport: "api/reportmgmt/getCatalogueSummaryReport",
  getInventorySummaryReport: "api/reportmgmt/getInventorySummaryReport",
  getInvoicesStatusAnalytics: "api/reportmgmt/getInvoicesStatusAnalytics",
  getAllSingleSuppliersList: "api/srmgmt/getALLSRs",
  createSingleSupplier: "api/srmgmt/createSR",
  getSRbySrNumber: "api/srmgmt/getSRbySrNumber",
  updateSingleSupplier: "api/srmgmt/updateSR",
  submitSingleSupplier: "api/srmgmt/submitSRApproval",
  approveSingleSupplier: "api/srmgmt/processSRApprovalStep",
  processSRNotes: "api/srmgmt/processSRNotes",
  generateSRReport: "api/srmgmt/generateSRReport",
  copySR: "api/srmgmt/copySR",
  syncSR: "api/srmgmt/syncsr",
  /** Bids API */

  getALLPublshBids: "api/bidmgmt/getALLPublshBids",
  getALLDraftBids: "api/bidmgmt/getALLDraftBids",
  getBidDetailsById: "api/bidmgmt/getBidDetailsById",
  createNewBid: "api/bidmgmt/createNewBid",
  deleteBid: "api/bidmgmt/deleteBid",
  processBidLine: "api/bidmgmt/processBidLine",
  deleteBidLine: "api/bidmgmt/deleteBidLine",
  uploadBidAttachments: "api/bidmgmt/uploadBidAttachments",
  updateBidAttachments: "api/bidmgmt/updateBidAttachments",
  downloadBidAttachment: "api/bidmgmt/downloadBidAttachment",
  deleteBidAttachments: "api/bidmgmt/deleteBidAttachments",
  addBidSuppliers: "api/bidmgmt/addBidSuppliers",
  delBidSuppliers: "api/bidmgmt/delBidSuppliers",
  getAllActiveSuppliers: "api/bidmgmt/getAllActiveSuppliers",
  getAllBidApprovers: "api/bidmgmt/getAllApprovers",
  saveBidTeam: "api/bidmgmt/saveBidTeam",
  deleteBidTeam: "api/bidmgmt/deleteBidTeam",
  saveBidReq: "api/bidmgmt/saveBidReq",
  getReqCategories: "api/bidmgmt/getReqCategories",
  deleteBidReq: "api/bidmgmt/deleteBidReq",
  saveBidClause: "api/bidmgmt/saveBidClause",
  deletebidClause: "api/bidmgmt/deletebidClause",
  publishBid: "api/bidmgmt/publishBid",
  getAllOpenBids: "api/bidmgmt/getAllOpenBids",
  getAllMyBidResponses: "api/bidmgmt/getAllMyBidResponses",
  acknowledgeBid: "api/bidmgmt/acknowledgeBid",
  getBidResponse: "api/bidmgmt/getBidResponse",
  updateBidReqResponse: "api/bidmgmt/updateBidReqResponse",
  updateBidReqRemarks: "api/bidmgmt/updateBidReqRemarks",
  updateBidPrice: "api/bidmgmt/updateBidPrice",
  updatePromisedDate: "api/bidmgmt/updatePromisedDate",
  uploadBidRespAttachments: "api/bidmgmt/uploadBidRespAttachments",
  updateTotal: "api/bidmgmt/updateTotal",
  saveAsDraftBidResponse: "api/bidmgmt/saveAsDraftBidResponse",
  submitBidResponse: "api/bidmgmt/submitBidResponse",
  processBidLineOther: "api/bidmgmt/processBidLineOther",
  delBidLineOthers: "api/bidmgmt/delBidLineOthers",
  suppViewBidResponse: "api/bidmgmt/suppViewBidResponse",
  createBidFromPR: "api/bidmgmt/createBidFromPR",
  createBidFromMR: "api/bidmgmt/createBidFromMR",
  getAllBidTemplates: "api/bidmgmt/getAllBidTemplates",
  saveBidAsTemplate: "api/bidmgmt/saveBidAsTemplate",
  processBidSupplierNotes: "api/bidmgmt/processBidSupplierNotes",
  inviteNewSuppliers: "api/bidmgmt/inviteNewSuppliers",
  cancelBid: "api/bidmgmt/cancelBid",
  holdBid: "api/bidmgmt/holdBid",
  reOpenBid: "api/bidmgmt/reOpenBid",
  closeBid: "api/bidmgmt/closeBid",
  bidreviewdates: "api/bidmgmt/bidreviewdates",
  processBidApprovalStep: "api/bidmgmt/processBidApprovalStep",
  uploadBondDocument: "api/bidmgmt/uploadBondDocument",
  openBid: "api/bidmgmt/openBid",
  updateenvelopstatus: "api/bidmgmt/updateenvelopstatus",
  sendOTPTender: "api/bidmgmt/sendOTPTender",
  validateTenderOtp: "api/bidmgmt/validateOtp",
  getBidEvaluateDtlsById: "api/bidmgmt/getBidEvaluateDtlsById",
  getBidResponseDtlsForScoring: "api/bidmgmt/getBidResponseDtlsForScoring",
  updateBidReqScore: "api/bidmgmt/updateBidReqScore",
  updateBidReqComments: "api/bidmgmt/updateBidReqComments",
  getRespTotalFinScoreUser: "api/bidmgmt/getRespTotalFinScoreUser",
  getRespTotalTechScoreUser: "api/bidmgmt/getRespTotalTechScoreUser",
  getRespTotalTechScore: "api/bidmgmt/getRespTotalTechScore",
  getRespTotalFinScore: "api/bidmgmt/getRespTotalFinScore",
  submitTechScore: "api/bidmgmt/submitTechScore",
  submitFinScore: "api/bidmgmt/submitFinScore",
  approveTechScore: "api/bidmgmt/approveTechScore",
  approveFinScore: "api/bidmgmt/approveFinScore",
  compareResponses: "api/bidmgmt/compareResponses",
  storeEvaluation: "api/bidmgmt/storeEvaluation",
  sendBidToEvaluationTeam: "api/bidmgmt/sendBidToEvaluationTeam",
  submitEvaluation: "api/bidmgmt/submitEvaluation",
  approveEvaluation: "api/bidmgmt/approveEvaluation",
  processEvaluationApprovalStep: "api/bidmgmt/processEvaluationApprovalStep",
  saveBidAdditionalKey: "api/bidmgmt/suppQuotationAddittionalInfo",
  compareBidCriteria: "api/bidmgmt/bulkUpdateBidReqResponse",
  awardBid: "api/bidmgmt/awardBid",
  getAwardDetails: "api/bidmgmt/getAwardDetails",
  saveAwardAsDraft: "api/bidmgmt/saveAwardAsDraft",
  submitAwardForApproval: "api/bidmgmt/submitAwardForApproval",
  processAwardApproval: "api/bidmgmt/processAwardApproval",
  acceptAward: "api/bidmgmt/acceptAward",
  rejectAward: "api/bidmgmt/rejectAward",
  requestNegotiation: "api/bidmgmt/requestNegotiation",
  downloadTechResponseDocs: "api/bidmgmt/downloadTechResponseDocs",
  downloadFinResponseDocs: "api/bidmgmt/downloadFinResponseDocs",
  createPOFromAward: "api/bidmgmt/createPOFromAward",
  cancelAward: "api/bidmgmt/cancelAward",
  getAllProdItemsByCategory: "api/productsmgmt/getALLProdItems",
  generateBidReport: "api/bidmgmt/generateReport",
  generateBidSRReport: "api/srmgmt/generateSRReport",
  syncBid: "api/bidmgmt/syncbiddtls",
  deleteProxyResponse: "api/bidmgmt/deletebidresponses",
  awardbidlist:"api/bidmgmt/getAllAwardBid",
  sendRegretMail:"api/bidmgmt/sendBidRegretMail",
  downloadJks: "api/bidmgmt/downloadJks",
  /** QuickbooksIntegration API */
  refreshBidStatus: "api/integrationmgmt/updateBidStatus",
  refreshMRStatus: "api/integrationmgmt/updateMRStatus",
  qbconnected: "api/integrationmgmt/qbconnected",
  connectToQuickbooks: "api/integrationmgmt/connectToQuickbooks",

  /** Payments API */
  createPaymentIntent: "api/paymentsmgmt/createPaymentIntent",

  /** Contracts Management **/
  getAllPublishedContracts: "api/contractmgmt/getAllPublishedContracts",
  getAllDraftContracts: "api/contractmgmt/getAllDraftContracts",
  createNewContract: "api/contractmgmt/createNewContract",
  getContractDetailsById: "api/contractmgmt/getContractDetailsById",
  deleteContract: "api/contractmgmt/deleteContract",
  addContractSupplier: "api/contractmgmt/addContractSupplier",
  deleteContractSupplier: "api/contractmgmt/deleteContractSupplier",
  saveContractTeam: "api/contractmgmt/saveContractTeam",
  deleteContractTeam: "api/contractmgmt/deleteContractTeam",
  publishContract: "api/contractmgmt/publishContract",
  getOpenContractsBySupplier: "api/contractmgmt/getOpenContractsBySupplier",
  getSignedContractsBySupplier: "api/contractmgmt/getSignedContractsBySupplier",
  saveContractDoc: "api/contractmgmt/saveContractDoc",
  importContractDoc: "api/contractmgmt/importContractDoc",
  supplierSubmitNegotiation: "api/contractmgmt/supplierSubmitNegotiation",
  buyerSubmitNegotiation: "api/contractmgmt/buyerSubmitNegotiation",
  acceptContractBySupplier: "api/contractmgmt/acceptContractBySupplier",
  submitForApproval: "api/contractmgmt/submitForApproval",
  processContractApprovalStep: "api/contractmgmt/processContractApprovalStep",
  submitForReview: "api/contractmgmt/submitForReview",
  acceptContractReview: "api/contractmgmt/acceptContractReview",
  rejectContractReview: "api/contractmgmt/rejectContractReview",
  getAllContractSections: "api/contractmgmt/getAllContractSections",
  processSections: "api/contractmgmt/processSections",
  delSections: "api/contractmgmt/delSections",
  getAllContractTerms: "api/contractmgmt/getAllContractTerms",
  processContractsTerms: "api/contractmgmt/processContractsTerms",
  deleteTerms: "api/contractmgmt/deleteTerms",
  publishTerm: "api/contractmgmt/publishTerm",

  /*prodyct-master*/
  addNewProduct: "api/productmaster/addNewProduct",
  getAllProducts: "api/productmaster/getAllProducts",
  getProductDetailsById: "api/productmaster/getProductDetailsById",
  getAllProductsByCategory: "api/productmaster/getAllProductsByCategory",
  processImportProductsXls: "api/productmaster/processImportProductsXls",

  /*auction-event-apis*/
  getAllEventTemplates: "api/auctionevents/getAllEventTemplates",
  createEventTemplate: "api/auctionevents/createEventTemplate",
  getEventTemplateById: "api/auctionevents/getEventTemplateById",
  createAuctionEvent: "api/auctionevents/createAuctionEvent",
  getAllTnCByModuleName: "api/admmgmt/getAllTnCByModuleName",
  createNewOrgTnC: "api/admmgmt/createNewOrgTnC",
  getAllActiveAuctions: "api/auctionevents/getAllActiveAuctions",
  getAllCompletedAuctions: "api/auctionevents/getAllCompletedAuctions",
  getAllUpcomingAuctions: "api/auctionevents/getAllUpcomingAuctions",
  getTnCByIds: "api/admmgmt/getTnCByIds",
  getAuction: "api/auctionevents/getAllActiveAuctions",
  getAuctionEventById: "api/auctionevents/getAuctionEventById",
  getAllAuctionEventsBySupplier:
    "api/auctionevents/getAllAuctionEventsBySupplier",
  getAllActiveAuctionBySupplier:
    "api/auctionevents/getAllActiveAuctionBySupplier",
  getAllCompletedAuctionBySupplier:
    "api/auctionevents/getAllCompletedAuctionBySupplier",
  getAllUpcomingAuctionBySupplier:
    "api/auctionevents/getAllUpcomingAuctionBySupplier",
  getAuctionEventDetailsById: "api/auctionevents/getAuctionEventDetailsById",
  saveSupplierResponse: "api/auctionevents/sendAuctionSuppRespEvents",
  getAuctionEventDetailsBySupp:
    "api/auctionevents/getAuctionEventDetailsBySupp",
  updateSupplierResponse: "api/auctionevents/updateAuctionSuppRespEvents",
  withdrawAuction: "api/auctionevents/withdrawAuction",
  broadCastMessage: "api/auctionevents/broadCastMessage",
  extendTimeRemain: "api/auctionevents/extendTimeRemain",
  updateSupplierAuctionSeenStatus:
    "api/auctionevents/updateSupplierAuctionSeenStatus",
  getBroadCastMessage: "api/auctionevents/getBroadCastMessage",
  getOrderActivity: "api/auctionevents/getOrderActivity",
  updateMinBidDiff: "api/auctionevents/updateMinBidDiff",
  addAuctionSuppliers: "api/auctionevents/addAuctionSuppliers",
  getBidSummary: "api/auctionevents/getBidSummary",
  getBidSummaryPartial: "api/auctionevents/getBidSummaryPartial",
  awardAuction: "api/auctionevents/awardAuction",
  updateAuctionAPI: "api/auctionevents/subscribeAu",
  submitAwardForApprovalAuction: "api/auctionevents/submitAwardForApproval",
  processAwardApprovalLot: "api/auctionevents/processAwardApproval",
  cancelAward: "api/auctionevents/cancelAward",
  getAwardDetailsAuction: "api/auctionevents/getAwardDetails",
  submitAwardApprovalPartial: "api/auctionevents/submitAwardApprovalPartial",
  processAwardApprovalPartial: "api/auctionevents/processAwardApprovalPartial",
  createPOFromAuction: "api/auctionevents/createPOFromAward",
  generateReport: "api/auctionevents/generateReport",

  /*Master Data Integration*/
  migrateMasterData: "api/integrationmgmt/migrateMasterData",
  vmsMasterData: "api/vmsintegrationmgmt/syncfailedrecords",
  testSuppIntegration: "api/integrationmgmt/testSuppIntegration",
  exUsers: "api/prokraya-world/Users",
  getAllMSTLogs: "api/integrationmgmt/getAllMSTLogs",
  getAllLogDtlRecords: "api/integrationmgmt/getAllLogDtlRecords",

  /*mobile-interface-apis*/
  mobGetAllAuctionEvents: "mobile/api/service/getAllAuctionEvents",
  mobGetAllActiveAuctions: "mobile/api/service/getAllActiveAuctions",
  mobGetAuctionsById: "mobile/api/service/getAuctionEventById",
};
